import script from "./contectPart.vue?vue&type=script&setup=true&lang=js"
export * from "./contectPart.vue?vue&type=script&setup=true&lang=js"

import "./contectPart.vue?vue&type=style&index=0&id=08fc14c3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fc14c3"]])

export default __exports__